import { UserType } from "../../../login/loginTypes"
import { CreateAdmin } from "../../../users/userTypes"
import {
    COMPANY_ADMIN_ROUTE,
    MERCHANT_ADMIN_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
    SUPPLIER_ADMIN_ROUTE,
    TENANT_ADMIN_ROUTE,
} from "../../../../constants/routes"

type GetAdminHomeRouteArgs = Pick<CreateAdmin, "type">

export function getHomeRoute({ type }: GetAdminHomeRouteArgs) {
    switch (type) {
        case UserType.OFFICE_MANAGER:
            return TENANT_ADMIN_ROUTE
        case UserType.MERCHANT:
            return MERCHANT_ADMIN_ROUTE
        case UserType.COMPANY:
            return COMPANY_ADMIN_ROUTE
        case UserType.SUPPLIER:
            return SUPPLIER_ADMIN_ROUTE
        case UserType.SUPPORT:
            //TODO: add when it'll be done
            return ""
        case UserType.SERVICE_CENTER:
            return SERVICE_CENTER_ADMIN_ROUTE
    }
}
